module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDpub25lO30uYntmaWxsOiNkNjMxMzE7fTwvc3R5bGU+PC9kZWZzPjxyZWN0IGNsYXNzPSJhIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz48cGF0aCBjbGFzcz0iYiIgZD0iTTgsMGE4LDgsMCwxLDAsOCw4QTguMDA5LDguMDA5LDAsMCwwLDgsMFptNCw4LjY2N0g0QS42NjcuNjY3LDAsMCwxLDQsNy4zMzNoOGEuNjY3LjY2NywwLDAsMSwwLDEuMzMzWiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theory/ic_lessinformation.svg
// module id = 571
// module chunks = 0